import React from 'react'
import { Text, useDisclosure } from '@chakra-ui/core'
import LocaleText from 'components/LocaleText'
import { PostModal } from '../NewsFeed/PostModal'
import { MessageSquare } from 'lucide-react'
import { ActionButton, IconBlock } from './NavMenu'

export const ComposeButton: React.FC<{ setIsHidden?: (isHidden: boolean) => void }> = ({ setIsHidden }) => {
  const { isOpen: isOpenPostModal, onOpen: onOpenPostModal, onClose: onClosePostModal } = useDisclosure()

  const handleOpenPostModal = () => {
    setIsHidden?.(true)
    onOpenPostModal()
  }

  const handleClosePostModal = () => {
    setIsHidden?.(false)
    onClosePostModal()
  }

  return (
    <>
      <ActionButton onClick={handleOpenPostModal}>
        <IconBlock borderRadius="10px" alignItems="center" justifyContent="center" bg="#D3EFCF">
          <MessageSquare size={18} color="#22C55E" />
        </IconBlock>
        <Text>
          <LocaleText text="componse_post" />
        </Text>
      </ActionButton>

      {isOpenPostModal && <PostModal isOpen={isOpenPostModal} onClose={handleClosePostModal} />}
    </>
  )
}
